// src/components/Admin/VirtualScenes/SceneForm/StepZero.js
import React, { useEffect } from "react";
import { Form, Button } from "semantic-ui-react";
import { Input, Select, Button as AntButton } from "antd";
import { useFormik } from "formik";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  validationSchemaZero,
  departamentOptions,
  accountOptions,
} from "./StepZero.form";
import { NEW_EDUCAMAKER } from "../../../../ui/featureFlags";
import { useTranslation } from "react-i18next";
import sx from "./SceneFormNew.module.scss";
import "./SceneForm.scss";

const toAntOptions = (opts) =>
  (opts || []).map((o) => ({ label: o.text, value: o.value }));

const virtualSceneController = new VirtualScenes();

export function StepZero({
  formData,
  updateFormData,
  nextStep,
  isUpdateMode,
  scene,
  onSceneCreated, // <--- Nueva prop recibida
}) {
  useEffect(() => {
    // Limpiamos al inicio
    localStorage.removeItem("idScene");
  }, []);

  const { accessToken, user } = useAuth();
  const { t } = useTranslation("scenes");

  const formik = useFormik({
    initialValues: {
      departament: formData.departament || "",
      idScene: formData.idScene || localStorage.getItem("idScene") || "",
      account: formData.account || "",
    },
    validationSchema: validationSchemaZero(),
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const payload = {
          departament: values.departament,
          idScene: values.idScene,
          account: values.account,
          user: user.user._id,
        };

        if (isUpdateMode) {
          await virtualSceneController.createModuleAdd(
            "module_00",
            accessToken,
            scene.refId,
            payload,
          );
        } else {
          // CREACIÓN
          const response = await virtualSceneController.createModule_00(
            accessToken,
            payload,
          );
          const newId = response.virtualScene._id;

          localStorage.setItem("idScene", newId);
          formik.setFieldValue("idScene", newId);

          // <--- AVISAMOS AL PADRE QUE HEMOS CREADO UNA ESCENA
          if (onSceneCreated) {
            onSceneCreated(newId);
          }
        }
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }

      updateFormData({
        ...values,
        idScene: formik.values.idScene,
        user: user.user._id,
      });
      nextStep();
    },
  });

  if (NEW_EDUCAMAKER) {
    return (
      <form className={sx.form} onSubmit={formik.handleSubmit}>
        <div className={sx.field}>
          <span className={sx.label}>{t("form.departmentLabel")}</span>
          <Select
            options={toAntOptions(departamentOptions)}
            value={formik.values.departament || undefined}
            disabled
            size="large"
          />
        </div>

        <div className={sx.field}>
          <span className={sx.label}>{t("form.sceneIdLabel")}</span>
          <Input
            name="idScene"
            size="large"
            value={formik.values.idScene}
            onChange={formik.handleChange}
            placeholder={t("form.sceneIdPlaceholder")}
          />
          {formik.errors.idScene ? (
            <span className={sx.error}>{formik.errors.idScene}</span>
          ) : null}
        </div>

        <div className={sx.field}>
          <span className={sx.label}>{t("form.accountTypeLabel")}</span>
          <Select
            options={toAntOptions(accountOptions)}
            value={formik.values.account || undefined}
            disabled
            size="large"
          />
        </div>

        <div className={sx.submitBlock}>
          <AntButton
            type="primary"
            htmlType="submit"
            size="large"
            block
            loading={formik.isSubmitting}
          >
            {t("form.nextButton")}
          </AntButton>
        </div>
      </form>
    );
  }

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      <Form.Select
        label={t("form.departmentLabel")}
        name="departament"
        options={departamentOptions}
        value={formik.values.departament}
        disabled
      />

      <Form.Input
        label={t("form.sceneIdLabel")}
        name="idScene"
        onChange={formik.handleChange}
        value={formik.values.idScene}
        placeholder={t("form.sceneIdPlaceholder")}
      />

      <Form.Select
        label={t("form.accountTypeLabel")}
        name="account"
        options={accountOptions}
        value={formik.values.account}
        disabled
      />

      <Form.Group>
        <Button
          type="submit"
          primary
          fluid
          loading={formik.isSubmitting}
          style={{ width: "100%" }}
        >
          {t("form.nextButton")}
        </Button>
      </Form.Group>
    </Form>
  );
}
